import { html, PropertyValues } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { property } from 'lit/decorators.js';
import { PublicAppElement } from './public-app-element';
import { parseDate } from '../modules/date_util'
export class TableJsonData {
    columnDefs: [];
    data: [];
    config: {
        maxRowsPerPage: 0;
        paginatorContainerSelector: '';
        rowClickHandler: (rowIndex, resRow) => {};
        cellClicked: (rowIndex, colIndex, resRow) => {};
    };
    charLimitForDesktop: 1000;
    charLimitForMobile: 250;
}

export class PublicAppTablePaginator extends PublicAppElement {
    @property({ type: Number }) accessor selectedRow = 0;
    @property({ type: Number }) accessor selectedId = -1;
    @property({ type: String }) accessor currentSort = "";
    @property({ type: Number }) accessor currentPageIndex = 0;
    private messageContent: string;
    private rowData = {};
    private tableDefinition: TableJsonData;
    get table(): TableJsonData {
        return this.tableDefinition;
    }
    @property({ type: Object })
    set table(value: TableJsonData) {
        const oldValue = this.tableDefinition;
        this.tableDefinition = value;
        this.requestUpdate('table', oldValue);
    }
    @property({type: Boolean}) accessor isMobile = false;
    firstUpdated(changedProperties: PropertyValues) {
        super.firstUpdated(changedProperties);

        window["bootstrapCollapseAll"] = this.bootstrapCollapseAll;
        window["bootstrapCollapse"] = this.bootstrapCollapse;
        window["onResetAccordion"] = this.resetAccordion;
    }
    getIsMobile() {
        const mobile = window.screen.width < 768 ? true : false;
        this.isMobile = mobile;
    }
    openAccordion() {
        this.getIsMobile();
        const messageId = this.selectedId === -1 ? this.table.data[this.selectedRow]["Message Id"] : this.selectedId;
        const first = this.shadowRoot?.querySelector('[id="'+messageId+'"]');
        if (first) {
            const button: any = first.querySelector("button");
            if (button && button.classList.contains("collapsed")) {
                button.classList.remove("collapsed");
                const show = first.nextElementSibling;
                new window["bootstrap"].Collapse(show, { toggle: true });
            }
        }
    }
    toggleAccordionGroup(e) {
        const button: any = e;
        const selElem = button?.closest(".accordion-item").querySelector(".accordion-collapse");
        const elems = button?.closest(".accordion").querySelectorAll('.collapse.show');
        this.bootstrapCollapseAll(elems, selElem);
        if (selElem) {
            !selElem.classList.contains("show") ? this.bootstrapExpand(selElem) : this.bootstrapCollapse(selElem);
        }
    }
    bootstrapCollapseAll(items, selElem = null) {
        if (items) {
            items.forEach(iter => {
                if (iter != selElem) {
                    window["bootstrapCollapse"](iter);
                }
            });
        }
    }
    bootstrapCollapse(item) {
        if (item) {
            new window["bootstrap"].Collapse(item);

            const selectedRow = item.closest(".accordion-item")?.querySelector(".paginator-selected-row");
            selectedRow?.classList.remove("paginator-selected-row");

            const button = item.closest(".accordion-item")?.querySelector("button");
            if (button && !button.classList.contains("collapsed")) {
                button.classList.add("collapsed");    
            }
        }
    }
    bootstrapExpand(item) {
        new window["bootstrap"].Collapse(item, { toggle: true })
        const button = item.closest(".accordion-item")?.querySelector("button");
        if (button && button.classList.contains("collapsed")) {
            button.classList.remove("collapsed");
        }
    }
    resetAccordion() {
        const tablePaginator = document.querySelector('public-app-table-paginator');
        const openAccordion = tablePaginator?.shadowRoot?.querySelectorAll('.collapse.show');
        window["bootstrapCollapseAll"](openAccordion);
    }
    truncateText(innerText) {
        const { charLimitForMobile, charLimitForDesktop } = this.table;
        let truncated = innerText.trim();
        const maxLength = this.isMobile ? charLimitForMobile : charLimitForDesktop;

        if (truncated.length > maxLength) {
            truncated = truncated.substr(0,maxLength) + `... <a class="text-decoration-underline float-end" role="button" id="read_more_text" data-bs-toggle="modal" data-bs-target="#noticesModal">Read More</a>`;
        }
        return truncated;
    }
    appendReadMoreOnclick(ele) {
        ele.innerHTML = this.truncateText(ele.innerHTML);
        let readMoreEle = ele.querySelector('#read_more_text')
        if(readMoreEle){
            readMoreEle.addEventListener('click', () => this.renderReadMoreModal(this));
        }               
    }
    displayMessage(row) {
        const accordionCollapse = row.nextElementSibling;
        const parser = new DOMParser();
        const parsedMessage = parser.parseFromString(this.messageContent, "text/html");
        const messageContent = accordionCollapse.querySelector('.notices-info');
        const message = parsedMessage.documentElement.querySelector('body')?.querySelector('#notices-message');
        const attachmentList = parsedMessage.documentElement.querySelector('body')?.querySelectorAll('.notices-attachment');

        if (messageContent) {
            if (messageContent.childNodes.length > 0) {
                while (messageContent.firstChild) {
                    messageContent.removeChild(messageContent.firstChild);
                }
            }

            if (message) {
                messageContent.appendChild(message);
                const noticeMessage = messageContent.querySelector("#notices-message");
                
                if(noticeMessage && noticeMessage.innerHTML){
                    this.appendReadMoreOnclick(noticeMessage)
                }
            }
            
            if (attachmentList && attachmentList.length > 0) {
                const attachments = document.createElement("div");
                attachments.setAttribute("class", "attachments");
    
                attachmentList.forEach(el => attachments.appendChild(el));
                messageContent.appendChild(attachments);
            }
        }
    }
    columnHeaderClicked(e) {
        if (!(this.table.data && this.table.data.length)) {
            return;
        }
        this.resetAccordion();
        let header: any = e.target;
        if (!header.classList.contains("header-column")) {
            header = header.closest(".header-column");
        }
        let currentSelectedRow = JSON.stringify(this.table.data[this.selectedRow]);
        this.selectedId = this.table.data[this.selectedRow]["Message Id"];
        let colIndex = + header.getAttribute("data-index");
        let curSortedCol: any = this.table.columnDefs && this.table.columnDefs[colIndex];
        let newSort = (curSortedCol && curSortedCol.sorted == "asc") ? "desc" : "asc";
        this.table.columnDefs.map(
            (col: any, index: number) => {
                col.sorted = index == colIndex ? newSort : undefined;
            }
        );
        this.table.data.sort((first, second) => { return this.compareRows(first, second, colIndex, newSort) });
        this.currentPageIndex = 0;
        this.currentSort = colIndex + "-" + newSort;
        this.selectedRow = this.table.data.findIndex((el) => { return JSON.stringify(el) === currentSelectedRow });
        this.updatedSortIcon(e);
    }
    compareRows(first: never, second: never, colIndex: number, newSort: string): number {
        if (this.table?.data?.length) {
            let colDefs: any = this.table.columnDefs;
            let retVal = 0;
            let curColDef = colDefs[colIndex];
            let firstVal = first[curColDef.key] + "";
            let secondVal = second[curColDef.key] + "";
            if (curColDef.parser === "datetime") {
                let fstDt = parseDate(firstVal, curColDef.parserFormat);
                let secDt = parseDate(secondVal, curColDef.parserFormat);
                if (!fstDt && !secDt) {
                    retVal = 0;
                } else if (!fstDt) {
                    retVal = -1;
                } else if (!secDt) {
                    retVal = 1;
                } else {
                    retVal = fstDt.getTime() - secDt.getTime();
                }
            } else if (curColDef.parser === "float") {
                let fstFloat = parseFloat(firstVal);
                let secFloat = parseFloat(secondVal);
                if (!fstFloat && !secFloat) {
                    retVal = 0;
                } else if (!fstFloat) {
                    retVal = -1;
                } else if (!secFloat) {
                    retVal = 1;
                } else {
                    retVal = fstFloat - secFloat;
                }
            } else {
                retVal = (firstVal).localeCompare(secondVal);
            }
            return newSort == "desc" ? -retVal : retVal;
        }
        return 0;
    }
    async rowClicked(e) {
        this.getIsMobile();
        let row: any = e;
        if (!row.classList.contains('accordion-header')) {
            row = row.closest(".accordion-header");
        }
        if (this.selectedId !== row.getAttribute("id")) {
            row.classList.add("paginator-selected-row");
            let rowIndex = + row.getAttribute("data-row-index");
            let resRow = this.table.data[rowIndex];
            this.selectedId = resRow["Message Id"];
            this.rowData = resRow;
            this.messageContent = await window["fetchNotice"](this.selectedId);
            this.displayMessage(row);
            this.selectedRow = rowIndex;
        } else {
            this.selectedId = -1;
        }

        this.toggleAccordionGroup(row);
    }
    cellClicked(e) {
        let row: any = e.target;
        let colIndex = + row.getAttribute("data-col-index");
        let rowIndex = + row.closest(".accordion-header").getAttribute("data-row-index");
        let resRow = this.table.data[rowIndex];
        if (this.table.config.cellClicked) {
            this.table.config.cellClicked(rowIndex, colIndex, resRow);
        }
    }
    onClickNavigator(selector, navTo) {
        let thisElement: PublicAppTablePaginator = document.querySelector(selector)
        if (!thisElement) {
            thisElement = document.querySelector("public-app-table-paginator") as PublicAppTablePaginator;
        }
        if (navTo === "first") {
            thisElement.currentPageIndex = 0;
        } else if (navTo === "prev") {
            thisElement.currentPageIndex--;
        } else if (navTo === "next") {
            thisElement.currentPageIndex++;
        } else if (navTo === "last") {
            let maxRows = thisElement.table?.config?.maxRowsPerPage;
            let dataLength = thisElement.table?.data?.length;
            if (maxRows && dataLength) {
                thisElement.currentPageIndex = Math.ceil(dataLength / maxRows) - 1;
            }
        } else {
            thisElement.currentPageIndex = +navTo - 1;
        }
    }
    setUpNavigator(currPage, maxRowsPerPage, dataLength) {
        window["onClickPublicAppTablePageNavigator"] = this.onClickNavigator;
        let elm = document.querySelector(this.table?.config?.paginatorContainerSelector);
        let myId = this.getAttribute("id");
        while (elm && elm.childNodes.length) {
            elm.childNodes[0].remove();
        }
        if (elm && maxRowsPerPage && dataLength) {
            let lastPage = Math.ceil(dataLength / maxRowsPerPage);
            elm.append(this.createNavElement(myId, "<<<span class='d-none d-sm-inline-block'>&nbsp;first</span>", "first", currPage == 0, false));
            elm.append(this.createNavElement(myId, "<<span class='d-none d-sm-inline-block'>&nbsp;prev</span>", "prev", currPage == 0, false));
            let start = this.currentPageIndex - 4;
            if (start < 0) start = 0;
            let last = start + 5;
            if (last > lastPage) last = lastPage;
            for (let i = start; i < last; i++) {
                elm.append(this.createNavElement(myId, (i + 1) + "", (i + 1) + "", i == this.currentPageIndex, i == this.currentPageIndex));
            }
            elm.append(this.createNavElement(myId, "<span class='d-none d-sm-inline-block'>next&nbsp;</span>>", "next", lastPage - 1 == currPage, false));
            elm.append(this.createNavElement(myId, "<span class='d-none d-sm-inline-block'>last&nbsp;</span>>>", "last", lastPage - 1 == currPage, false));
        }
    }
    createNavElement(myId: any, text: string, navTo: any, disabled: boolean, isSelectedIndex: boolean) {
        let d = document.createElement("div");
        let a = document.createElement("a");
        a.innerHTML = text;
        a.href = "#";
        d.setAttribute("onclick", "onResetAccordion(); onClickPublicAppTablePageNavigator('#" + myId + "','" + navTo + "'); return false;");
        if (isSelectedIndex) {
            d.classList.add("paginator-navigation-selected");
        } else if (disabled) {
            d.classList.add("paginator-navigation-disabled");
            d.setAttribute("onclick", "return false;");
        } else {
            d.classList.add("paginator-navigation");
        }
        d.append(a);
        d.classList.add("paginator-navigation");
        if (!isNaN(navTo) && !isSelectedIndex) {
            d.classList.add("paginator-navigation-button");
        }
        return d;
    }
    getSortedIcon(sorted) {
        if (!sorted) return "table-column-header";
        return sorted === "desc" ? "table-column-header sorted sort-descending" : "table-column-header sorted sort-ascending";
    }
    getCellClass(key) {
        return key.replace(/\s/g, '-').toLowerCase();
    }
    getCategoryClass(colKey, category) {
        let className: string = "";

        if (colKey === "Category")
            className +=  " notice-category " + category.toLowerCase().replace(/ /g, "-").replace(/&/g, "");
        
        return className;
    }
    updatedSortIcon(e) {
        if (e && e.currentTarget.classList.contains("sorted")) {
            const checvronIcon = e.currentTarget.querySelector('[class*="bi-chevron"]');

            if (e.currentTarget.classList.contains("sort-descending")) {
                checvronIcon?.classList.replace('bi-chevron-up', 'bi-chevron-down');
            } 
            if (e.currentTarget.classList.contains("sort-ascending")) {
                checvronIcon?.classList.replace('bi-chevron-down', 'bi-chevron-up');
            }
        }
    }
    renderReadMoreModal(row) {
        const { rowData } = row;
        window["showNotice"](this.messageContent, rowData["Message Id"], rowData['Message Subject'], rowData['Category'], rowData['Date Posted'], false)
    }
    renderTableColumnHeader() {
        return html`
        ${this.table.columnDefs.map(
            (col: any, index: number) => html`
                <div class="header-column ${this.getCellClass(col.key)} ${this.getSortedIcon(col.sorted)}" data-index=${index} @click=${this.columnHeaderClicked}>
                    ${unsafeHTML(col.label)} ${col.sortable ? html `<i class="bi bi-chevron-down"></i>` : ''}
                </div>`
        )}`;
    }
    renderTableData() {
        let table = this.table.data;
        let startIndex = 0;
        let maxRows = this.table?.config?.maxRowsPerPage;
        let dataLength = this.table?.data?.length;
        if (maxRows && dataLength > maxRows) {
            startIndex = this.currentPageIndex * maxRows;
            if (startIndex >= dataLength || startIndex < 0) {
                startIndex = 0;
            }
            table = table.slice(startIndex, startIndex + maxRows) as never;
        }
        this.setUpNavigator(this.currentPageIndex, maxRows, dataLength);
        return html`
            ${table.map((row: any, rowIndex: number) => html`
                <div class="accordion-item">
                    <div class="accordion-header" id="${row['Message Id']}" @click=${(e) => this.rowClicked(e.target)} data-row-index=${rowIndex + startIndex}>
                        <button @click=${e => e.preventDefault()} class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse${row['Message Id']}" aria-expanded="true" aria-controls="collapse${rowIndex + startIndex}">
                            ${this.table.columnDefs.map((col: any, index: number) => html`
                                <div class="table-paginator-cell ${this.getCellClass(col.key)}" data-col-index=${index} @click=${this.cellClicked}><div class="${this.getCategoryClass(col.key, row[col.key])}">${unsafeHTML(row[col.key])}</div></div>`
                            )}
                        </button>
                    </div>
                    <div id="collapse${row['Message Id']}" class="accordion-collapse collapse" aria-labelledby="${row['Message Id']}" data-bs-parent="#noticesAccordion">
                        <div class="accordion-body">
                            <span class="chevron-icon-column"></span>
                            <div class="notices-info"></div>
                        </div>
                    </div>
                </div>`
            )}
        `;
    }
    renderTables() {
        return html`
            <div class="paginator-table">
                <div class="paginator-table-header d-none d-md-flex">
                    <div class="chevron-icon-column table-column-header">&nbsp;</div>
                    ${this.renderTableColumnHeader()}
                </div>
                <div class="accordion paginator-table-body" id="noticesAccordion">
                    ${this.renderTableData()}
                </div>
            </div>
        `;
    }
    render() {
        return html`
            <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
            ${(this.table && this.table.data && this.table.data.length) ? this.renderTables() : html``}`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-table-paginator': PublicAppTablePaginator;
    }
}